import React from 'react';

const STEPS = [
  {
    title: 'Sign in',
    body:
      'Create an account with a username and password. Your account is private — no public callsigns, no open band.',
  },
  {
    title: 'Pick a channel',
    body:
      'Choose a friend, jump into one of your private groups, or flip the 5-mile radius on to find drivers right around you.',
  },
  {
    title: 'Hold to talk',
    body:
      'Press the big PTT button, speak your piece, release. Your voice clip uploads, the server pushes it over a WebSocket, and the whole channel hears you.',
  },
];

export const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works">
      <div className="container">
        <span className="section-eyebrow">How it works</span>
        <h2 className="section-title">From sign-in to first transmission in under a minute.</h2>
        <p className="section-subtitle">
          No hardware, no install, no FCC license. Open RoadStatic on the
          phone in your cup holder and start talking.
        </p>

        <div className="how-grid">
          {STEPS.map((s) => (
            <div className="how-step" key={s.title}>
              <h3>{s.title}</h3>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
